export class ShowHideLogs {

    Id: number;
    HiddenByUserId: number;
    CandidateTypeId: number;
    JobId: number;
    CandidateId: number;
    CreatedOn: Date;
    IsActive: boolean;
}